import React from 'react';
import { motion } from 'framer-motion';

const Section09CTA = () => {
  return (
    <section className="relative section-pad section-glass" id="cta">
      {/* Subtle upper gradient that marks the final section */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'linear-gradient(180deg, rgba(0,212,170,0.04) 0%, rgba(11,17,32,0) 40%)',
        }}
      />

      <div className="container-edge relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-5xl space-y-10"
        >
          <h2
            className="font-display font-bold text-white leading-[0.9] tracking-tight"
            style={{ fontSize: 'clamp(3rem, 8vw, 7rem)' }}
          >
            Your content is<br />
            <span className="text-coral">leaking right now.</span>
          </h2>

          <p className="editorial-body max-w-3xl">
            The technology exists to find the source and stop it{' '}
            <span className="text-white">during the live event.</span>
            <br />
            The only question is whether you&rsquo;re still spending on takedown
            notices, or ready to stop piracy at source.
          </p>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="flex flex-col sm:flex-row items-start sm:items-center gap-6"
          >
            <a
              href="mailto:hello@kinesight.com?subject=Kinesight%20briefing%20request"
              className="btn-teal text-base"
            >
              Request a briefing
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 5l7 7-7 7" />
              </svg>
            </a>
            <a
              href="mailto:hello@kinesight.com"
              className="text-white/70 hover:text-teal transition-colors font-mono text-sm uppercase tracking-[0.3em] underline underline-offset-[6px] decoration-white/20 hover:decoration-teal"
            >
              hello@kinesight.com
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.35, duration: 0.8 }}
            className="pt-16 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16 max-w-4xl border-t border-white/5"
          >
            {[
              {
                k: '4s',
                v: 'Average detection time from pirate stream to identified source.',
              },
              {
                k: '60%',
                v: 'Piracy reduction achieved by LaLiga with source-level protection.',
              },
              {
                k: '$1.08B',
                v: 'Recoverable annual revenue at 9% pirate-to-customer conversion.',
              },
            ].map((item) => (
              <div key={item.k} className="pt-8 space-y-3">
                <p
                  className="stat-number text-teal"
                  style={{ fontSize: 'clamp(2.5rem, 5vw, 4.5rem)' }}
                >
                  {item.k}
                </p>
                <p className="text-white/60 leading-[1.5] text-sm md:text-base">
                  {item.v}
                </p>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Section09CTA;
